<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="fixed inset-0 z-[140] flex items-center justify-center bg-black/55 backdrop-blur-[6px] px-4"
      @click.self="closeModal"
    >
      <button
        type="button"
        class="absolute right-8 top-8 text-2xl leading-none text-white transition-opacity hover:opacity-70"
        aria-label="Close"
        @click="closeModal"
      >
        x
      </button>

      <div class="relative w-full max-w-[450px] rounded-[12px] bg-white px-10 md:py-16 py-10 text-[#1f1f1f] shadow-2xl">
        <button
          type="button"
          class="sr-only"
          aria-label="Close"
          @click="closeModal"
        >
          x
        </button>

        <h3 class="text-center md:text-[40px] text-[30px] font-semibold leading-[1.05] tracking-[-0.02em]">Get the Burse app</h3>
        <p class="mt-3 text-center md:text-lg text-[#6b6b6b]">Scan the QR code to download the app</p>

        <div class="mt-6 flex justify-center">
          <img :src="qrCode" alt="Scan QR code to download the Burse app" class="h-[92px] w-[92px]" />
        </div>

        <p class="md:my-6 my-5 text-center text-lg text-[#8b8b8b]">or</p>

        <div class="flex items-center justify-center gap-2 mt-5 w-full">
            <wnp-button onclick="" class="min-w-[140px] max-w-[200px] w-[160px] text-sm md:text-lg py-6 font-bold" size="xsmall">
              <span class="inline-flex items-center gap-2">
                <img :src="AppStoreIcon" alt="" aria-hidden="true" class="h-6 w-6 object-contain" />
                <span class="text-[16px]">App Store</span>
              </span>
            </wnp-button>
            <wnp-button onclick="" class="min-w-[140px] max-w-[200px] w-[160px] text-xs md:text-lg py-6 !bg-slate-100 text-black font-bold" size="xsmall" variants="light">
              <span class="inline-flex items-center gap-2 text-black">
                <img :src="PlayStoreIcon" alt="" aria-hidden="true" class="h-6 w-6 object-contain" />
                <span class="text-black text-[16px]">Google Play</span>
              </span>
            </wnp-button>
          </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import qrCode from "../assets/qrcode2.svg?url";
import PlayStoreIcon from "../assets/landing/p-store.png";
import AppStoreIcon from "../assets/landing/apple.png";
import WnpButton from "./ui/WnpButton.vue";

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  appStoreUrl: {
    type: String,
    default: "",
  },
  playStoreUrl: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:modelValue"]);

const closeModal = () => {
  emit("update:modelValue", false);
};
</script>
